export default __webpack_public_path__ + "static/logo-4e45dd2ae9e79a48a3b4d9514ae28255.png";